export const JOB_APPOINTMENT_GUID_QUERY_PARAM = 'ja' as const
export const ESTIMATE_TEMPLATE_GUID_QUERY_PARAM = 'et' as const
